const getters = {
  getGadgets: (state) => state.gadgets,
  getGadgetsMeta: (state) => state.gadgetsMeta,
  // this is used for lazy loading
  getGadgetsAll: (state) => state.gadgetsAll,
  getPolicies: (state) => state.policies,
  getPoliciesMeta: (state) => state.policiesMeta,
  // this is used for lazy loading
  getPoliciesAll: (state) => state.policiesAll,
  getPolicy: (state) => state.policy,
  getClaims: (state) => state.claims,
  getClaimsMeta: (state) => state.claimsMeta,
  // this is used for lazy loading
  getClaimsAll: (state) => state.claimsAll,
  getClaim: (state) => state.claim,
  getPartners: (state) => state.partners,
  getProducts: (state) => state.products,
  getProductCategories: (state) => state.productCategories,
  getUploadProgress: (state) => state.uploadProgress,
  getCreatePolicy: (state) => state.createPolicy,
  getGadgetCategory: (state) => state.gadgetCategory,
  getProductService: (state) => state.productService,
  getProductServiceBuybackProgram: (state) =>
    state.productServiceBuybackProgram,
  getListBrand: (state) => state.listBrand,
  getListType: (state) => state.listType,
  getCreateClaim: (state) => state.createClaim,
  getIsValidCreateClaim: (state) => state.isValidCreateClaim,
  getQuestionCostEstimation: (state) => state.questionCostEstimation,
  getFilesCostEstimation: (state) => state.filesCostEstimation,
  getExtractImei: (state) => state.extractImei,
  getPaymentMethod: (state) => state.paymentMethod,
  getAgents: (state) => state.agentList,
  getEditPolicyHistory: (state) => state.editPolicyHistory,
  getClaimsHistoriesClaim: (state) => state.claimsHistoriesClaim,
  getServiceCenters: (state) => state.serviceCenters,
};

export default getters;
